import {addManyFilter} from '../filter/filterSlice';
import { apiSlice } from './../../features/api/apiSlice';

export const projectApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: () => ({
                url: `/projects`
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const projects = await queryFulfilled;
                    if (projects?.data?.length > 0) {
                        // update filter cache pessimistically
                        dispatch(addManyFilter(projects.data));
                    
                    }
                } catch (err) {}
            },
        }),
    }),
});

export const { useGetProjectsQuery} = projectApi;